import React from 'react'
import styles from 'components/shared/icons/icons.module.scss'
import cn from 'classnames'
import { Bell } from 'lucide-react'

export default function NotiIcon(props) {
    const {
        contextStyles,
        hoverStyles,
        selectedStyles,
        numNoti,
        canActive,
        activeStyles,
        showIcon,
        size,
        showNumNoti,
        absolute,
    } = props

    const notiActive = canActive && numNoti > 0 ? activeStyles || styles.notiActive : null

    return (
        <div
            className={cn(
                styles.iconComp,
                styles.notiIcon,
                contextStyles,
                hoverStyles,
                selectedStyles,
                notiActive,
            )}
        >
            {showIcon && <Bell className={cn(styles.bell)} />}

            {showNumNoti && numNoti > 0 && (
                <span className={cn(styles.counter, absolute && styles.absolute)}>{numNoti}</span>
            )}
        </div>
    )
}
